module.exports = __webpack_public_path__ + "fonts/icons.192f982.woff";